<script>

import TasksForm from './TasksForm';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { TasksForm },
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      search: '',
      dateRange: { startDate: null, endDate: null },
      start_dateRange: { startDate: null, endDate: null },
      due_dateRange: { startDate: null, endDate: null },
      completed_dateRange: { startDate: null, endDate: null },


      status_list: [
        {id: '1', name: 'Draft', active: false},
        {id: '2', name: 'Active', active: false},
        {id: '3', name: 'Hold', active: false},
        {id: '4', name: 'Complete', active: false},
        {id: '0', name: 'Trash', active: false},
      ],
      priority_list: [
        {id: '1', name: 'Low', active: false},
        {id: '2', name: 'Normal', active: false},
        {id: '3', name: 'High', active: false},
      ],

      default_new_task: {
        status: 1,
        priority: 2,
        parent_id: '',
        project_folders: [],
        title: '',
        summary: '',
        content_type: 'doc',
        content: '',
        start_date: '',
        due_date: '',
        completed_date: '',
      },
      new_task: {},

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        wherenulls: ['parent_id'],
        whereins: {
          status: [],
          priority: [],
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          },
          start_date: {
            start: '',
            end: ''
          },
          due_date: {
            start: '',
            end: ''
          },
          completed_date: {
            start: '',
            end: ''
          },
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    'start_dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.start_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.start_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.start_date.start = '';
        this.filters.betweens.start_date.end = '';
      }
    }, deep: true },
    'due_dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.due_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.due_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.due_date.start = '';
        this.filters.betweens.due_date.end = '';
      }
    }, deep: true },
    'completed_dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.completed_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.completed_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.completed_date.start = '';
        this.filters.betweens.completed_date.end = '';
      }
    }, deep: true },

    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }

    this.new_task = JSON.parse(JSON.stringify(this.default_new_task));

    this.setWhereIns('status_list','filters','status');
    this.setWhereIns('priority_list','filters','priority');
    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/tasks/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
    checkSubTasks(task, result = 0) {
      for(var i in task.tasks) {
        result = result + 1;
        result = this.checkSubTasks(task.tasks[i], result);
      }
      return result;
    },
    add_task() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/tasks/store', this.new_task).then(res => {
        // console.log(res);
        this.new_task = JSON.parse(JSON.stringify(this.default_new_task));
        this.$refs.modal_add_task.hide();
        this.fetchData();
        this.dsbl_btn = false;
        if(res.data.id) { this.$router.push('/tasks/'+res.data.id); }
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <button type="button" @click="new_task = JSON.parse(JSON.stringify(default_new_task)); $refs.modal_add_task.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_task" centered size="xl" title="Create a new task" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <b-form @submit.prevent="add_task">
              <div class="p-4">
                <TasksForm :item="new_task"></TasksForm>
              </div>
              <footer class="modal-footer">
                <button type="button" class="btn btn-light" @click="$refs.modal_add_task.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
                <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
              </footer>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Status: ({{status_list.filter(b=>{return b.active}).length}}/{{status_list.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in status_list" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('status_list','filters','status'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Priority: ({{priority_list.filter(b=>{return b.active}).length}}/{{priority_list.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in priority_list" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('priority_list','filters','priority'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="start_dateRange" placeholder="Filter by start date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="due_dateRange" placeholder="Filter by due date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="completed_dateRange" placeholder="Filter by completed date .." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead>
              <tr>
                <th><tdsort coltext="Status" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Priority" :orderby.sync="filters.orderbys.priority" @do="fetchData()"></tdsort></th>
                <th>Sub tasks</th>
                <th>Assigned to</th>
                <th><tdsort coltext="Start date" :orderby.sync="filters.orderbys.start_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Due date" :orderby.sync="filters.orderbys.due_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Completed date" :orderby.sync="filters.orderbys.completed_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th><tdsort coltext="Status" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Priority" :orderby.sync="filters.orderbys.priority" @do="fetchData()"></tdsort></th>
                <th>Sub tasks</th>
                <th>Assigned to</th>
                <th><tdsort coltext="Start date" :orderby.sync="filters.orderbys.start_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Due date" :orderby.sync="filters.orderbys.due_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Completed date" :orderby.sync="filters.orderbys.completed_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/tasks/'+item.id" tag="tr" class="_c-pointer" exact>
                <td class="p-1">
                  <div class="alert small m-0 text-white" :class="'bg-'+(item.status == 0 ? 'danger' : item.status == 1 ? 'purple' : item.status == 2 ? 'warning' : item.status == 3 ? 'blue' : item.status == 4 ? 'success' : 'dark')">{{ (item.status == 0 ? 'Trash' : item.status == 1 ? 'Draft' : item.status == 2 ? 'Active' : item.status == 3 ? 'Hold' : item.status == 4 ? 'Complete' : '') }}</div>
                </td>
                <td class="py-1">
                  <router-link :to="'/tasks/'+item.id">
                    <div class="text-dark font-weight-bold"> {{item.title}}</div>
                    <div class="small text-muted text-truncate _w-m-500">{{item.summary}}</div>
                  </router-link>
                </td>
                <td class="p-1">
                  <div class="alert small m-0" :class="'alert-'+(item.priority == 1 ? 'teal' : item.priority == 2 ? 'light' : item.priority == 3 ? 'danger' : 'dark')">{{ (item.priority == 1 ? 'Low' : item.priority == 2 ? 'Normal' : item.priority == 3 ? 'High' : '') }}</div>
                </td>
                <td>{{checkSubTasks(item)}}</td>
                <td class="py-1">
                  <div v-for="(assign, assign_i) in item.assigned_to" :key="assign_i" class="d-inline-block _w-40 mr-2 align-top" v-tippy :content="`<div class='col p-0 small'><h6 class='mb-0'>`+assign.name+`</h6><div class='text-muted small _lh-16'>`+assign.email+`</div><div class='text-muted small _lh-16'>`+formatPhone(assign.phone)+`</div></div>`">
                    <img v-if="assign.avatar" :src="formatImage(assign.avatar)" class="_w-40 rounded">
                    <avatar v-else :username="assign.name" :size="40" :rounded="false" class="rounded"></avatar>
                  </div>
                </td>
                <td v-tippy :content="item.start_date ? moment(item.start_date).fromNow() : '' ">{{ item.start_date ? moment(item.start_date).format('MM-DD-YYYY') : '' }}</td>
                <td v-tippy :content="item.due_date ? moment(item.due_date).fromNow() : '' ">{{ item.due_date ? moment(item.due_date).format('MM-DD-YYYY') : '' }}</td>
                <td v-tippy :content="item.completed_date ? moment(item.completed_date).fromNow() : '' ">{{ item.completed_date ? moment(item.completed_date).format('MM-DD-YYYY') : '' }}</td>
                <td v-tippy :content="item.created_at ? moment(item.created_at).fromNow() : '' ">{{ item.created_at ? moment(item.created_at).format('MM-DD-YYYY') : '' }}</td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
